function layoutMobile(isMobile) {
  return {
    type: "LAYOUT_MOBILE",
    data: isMobile,
  };
}

export default layoutMobile;



// WEBPACK FOOTER //
// ./assets/shared/actions/layoutMobile.js